import React, { useContext, useEffect, useState } from 'react'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import { isEmpty } from 'lodash'
import CustomAccordion from 'src/components/customAccordion/customAccordion'
import AttachContent from '../attachContent'

const DefaultBannerPlayerCardModal = ({
  cancelCardModal,
  slidesData,
  setSlidesData,
  isEdit,
  singleSlideData,
  setSingleSlideData,
  editCardIndex,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)
  const [imageS3key, setImageS3key] = useState('')

  const [link, setLink] = useState({ type: '', data: {} })
  const [player, setPlayer] = useState({
    type: '',
    data: {},
  })
  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState([])

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'mdImage',
        width: 1420,
        height: 800,
        divwidth: '14.375rem',
        divheight: '8.125rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        imagePaddingX: '7px',
        imagePaddingY: '7px',
      },
    ]

    if (isEdit) {
      let tempdata = singleSlideData
      if (!isEmpty(singleSlideData)) {
        setImageS3key(tempdata.image_s3_key)
        imgData[0]['assetId'] = tempdata.image_s3_key
        imgData[0]['imageUrl'] = getThumbnail(
          userSessionObj?.session_data?.cf_domain_name,
          tempdata.image_s3_key,
        )
        setLink(tempdata.link)
        setPlayer(tempdata.player)
      }
    }

    setImageData(imgData)
  }, [])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (imageS3key.trim().length === 0) {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    if (link.type && !validateLink(link).isValid) {
      isFormValid = false
      temp.link = validateLink(link).error
    }

    // if (!player.type) {
    //   isFormValid = false
    //   temp.player = 'Select Valid Content'
    // }

    setErrorData({ ...temp })
    return isFormValid
  }

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const handleSave = () => {
    if (!validateInfo()) return

    let elementObj = {
      image_s3_key: imageS3key,
      link: link,
      player: player,
    }
    if (isEdit) {
      let slides = [...slidesData]
      slides[editCardIndex] = elementObj
      setSlidesData(slides)
      setSingleSlideData({})
    } else {
      setSlidesData((slidesData) => [...slidesData, elementObj])
      setSingleSlideData({})
    }
    cancelCardModal()
  }

  let accordionItems = [
    {
      title: 'Add Image',
      description:
        'Specify the image which you would like to display in the slides of the banner section of the template.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5' }}
          className=" px-4 py-3 d-flex flex-column justify-content-center align-items-center"
        >
          <ImageUploader data={imageData} />
          <span className="mt-2" style={{ fontSize: '11px', color: '#707070' }}>
            Image should be of 1420px X 801px and 3 MB size.
          </span>
          <div className="message-text error-message">
            <p>{errorData.imageS3key}</p>
          </div>
        </div>
      ),
      itemStyle: '',
    },
    {
      title: 'Add Navigation Link',
      description:
        'Specify the link to which you would like to redirect after clicking the banner of the template.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className="px-4 py-3">
          <AttachLink
            title=""
            linkData={link}
            id={'ctaButton'}
            categoryData={
              categoryList
                ? categoryList?.data.filter((info, idx) => info.type === 'category' && info.status)
                : []
            }
            setLinkData={(value) => {
              clearError('ctaButtonLink')
              setLink(value)
            }}
          />
          <div className="message-text error-message">
            <p>{errorData?.link}</p>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Add Video',
      description:
        'Specify the Video which you would like to display in the slides of the banner section.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className="px-4 py-3">
          <AttachContent
            linkData={player}
            id={'player'}
            setLinkData={(value) => {
              // clearError('player')
              setPlayer(value)
            }}
          />
          <div className="message-text error-message">
            <p>{errorData.player}</p>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
  ]

  return (
    <CModal
      size="lg"
      scrollable
      className="default-banner-card-modal"
      alignment="center"
      visible={true}
    >
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalHeader style={{ borderBottom: 0 }} className="d-flex justify-content-center mt-3">
        <p style={{ fontSize: '1.5rem' }}>
          <b style={{ fontWeight: '500' }}>Single Banner Editor</b>
        </p>
      </CModalHeader>
      <CModalBody
        style={{ minHeight: '50vh' }}
        className=" static-scrollbar-class d-flex flex-column justify-content-between"
      >
        <div className="d-flex justify-content-center">
          <div
            style={{ width: '82%' }}
            className="flex flex-column justify-content-center align-items-center"
          >
            <CustomAccordion items={accordionItems} styles={''} />
          </div>
        </div>
      </CModalBody>
      <CModalFooter style={{ borderTop: 0 }} className="">
        <div style={{ marginRight: '9%' }} className="pb-3">
          <CButton
            style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
            className="mx-4 bg-white rounded-1 btn-focus-none"
            onClick={() => {
              cancelCardModal()
            }}
          >
            Cancel
          </CButton>
          <CButton
            style={{ fontSize: '1.1rem' }}
            className=" bg-black rounded-1 btn-focus-none px-3"
            onClick={() => {
              handleSave()
            }}
          >
            Save
          </CButton>
        </div>
      </CModalFooter>
    </CModal>
  )
}

export default DefaultBannerPlayerCardModal
